import React from "react";
import { Container } from "../common/Container/Container";
import { Flex } from "../ui-component/Flex/Flex";
import { PositionBox, StyledFooter, StyledFooterText } from "./Footer.styled";

export const Footer = () => {
	return (
		<Container>
			<StyledFooter>
				<StyledFooterText>© Kozhoma Bogdan 2023</StyledFooterText>
				<Flex mobileDirection="column">
					<PositionBox>kozhoma.b@gmail.com</PositionBox>
					<StyledFooterText>(093) 905 38 98</StyledFooterText>
				</Flex>
			</StyledFooter>
		</Container>
	);
};
